/*
 * @Author: changcheng
 * @LastEditTime: 2025-01-22 13:46:46
 */
import { Button, Modal, Radio } from "antd";
import { useState } from "react";
import { post } from "../../../common/fetch";
import { useHistory } from "react-router-dom";
import { Base64 } from "js-base64";
import wechatIcon from "../../../img/weChatPay.png";
import aliIcon from "../../../img/aliPay.png";
export default function SelectCourse(props: {
  totalPrice: number;
  commodityId: string;
  showOrderModal: boolean;
  commodityName: string;
  setShowOrderModal: (show: boolean) => void;
}) {
  const history = useHistory();
  const [paymentType, setPayMentType] = useState("wechat");
  const { showOrderModal, setShowOrderModal, commodityId, totalPrice,commodityName } = props;
  /**
   * 支付订单
   * @param values 表单字段
   */
  const confirmOrderInfo = async () => {
    if (paymentType === "wechat") {
      wechatPay();
    } else {
      aliPay();
    }
  };
  /**
   * 微信支付
   * @param values
   */
  const wechatPay = async () => {
    const {
      data: { weChatPayQrCode, tradeNo },
    } = await post(
      `/shop/front/commodity/pc/commodity/${commodityId}/create/weChat/pay/order`,
      {},
      true
    );
    setShowOrderModal(false);
    history.push(
      `/wechatPay?amount=${totalPrice*100}&payCode=${Base64.encode(
        weChatPayQrCode
      )}&tradeNo=${tradeNo}`
    );
  };
  /**
   * 阿里支付
   * @param values
   */
  const aliPay = async () => {
    const {
      data: { orderNo },
    } = await post(
      `/shop/front/commodity/pc/commodity/${commodityId}/create/ali/pay/order`,
      {},
      false
    );
    setShowOrderModal(false);
    const returnUrl = encodeURIComponent(`${window.location.href}`);
    window.location.href = `https://api.imed.org.cn/order/createAliPayOrder?payType=ALI_PAY&tradeNo=${orderNo}&returnUrl=${returnUrl}&tradeType=NATIVE`;
  };
  return (
    <Modal
      visible={showOrderModal}
      title="支付订单"
      footer={null}
      onCancel={() => {
        setShowOrderModal(false);
      }}
    >
      <h5>{commodityName}</h5>
      <p>订单金额：¥{totalPrice}</p>
      <Radio.Group
        value={paymentType}
        onChange={(e) => {
          setPayMentType(e.target.value);
        }}
      >
        <Radio value="wechat">
          <img src={wechatIcon} alt="" className="payIcon" />
        </Radio>
        <Radio value="ali">
          <img src={aliIcon} alt="" className="payIcon" />
        </Radio>
      </Radio.Group>
      <div className="payBtn" style={{ marginTop: "20px" }}>
        <Button
          type="primary"
        onClick={() => {
          confirmOrderInfo();
        }}
        >
          确认
        </Button>
      </div>
    </Modal>
  );
}
